const mobilePageTitles = [
  { route: '/quote', title: 'Quote' },
  { route: '/users', title: 'Users' },
  { route: '/opportunities', title: 'Opportunities' },
];

export default mobilePageTitles;
